import AdminToolsWidget from '../AdminToolsWidget'
import LangSelect from '../LangSelect'
import UserProfileWidget from '../UserProfileWidget'
import './index.scss'

const Header = () => {
  return (
    <div className="Header">
      <UserProfileWidget />
      <AdminToolsWidget />
      <LangSelect />
    </div>
  )
}

export default Header
